/* eslint-disable no-param-reassign, func-names, prefer-rest-params */
Accounts.oauth.registerService('esri');

if (Meteor.isClient) {
  const loginWithEsri = function (options, callback) {
    // support a callback without options
    if (!callback && typeof options === 'function') {
      callback = options;
      options = null;
    }

    const credentialRequestCompleteCallback =
    Accounts.oauth.credentialRequestCompleteHandler(callback);
    Esri.requestCredential(options, credentialRequestCompleteCallback);
  };
  Accounts.registerClientLoginFunction('esri', loginWithEsri);
  Meteor.loginWithEsri = function () {
    return Accounts.applyLoginFunction('esri', arguments);
  };
} else {
  Accounts.addAutopublishFields({
    // publish all fields including access token, which can legitimately
    // be used from the client (if transmitted over ssl or on
    // localhost)
    // https://developers.arcgis.com/rest/users-groups-and-items/user.htm,
    // "Sharing of Access Tokens"
    forLoggedInUser: ['services.esri'],
    forOtherUsers: ['services.esri.email'],
  });
}
